














import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import {
  maxAllocationPercent,
  minAllocationPercent,
} from "../../allocation-workspace/allocation-state";

@Component
export default class PercentageInput extends Vue {
  @Prop({ required: true }) public readonly value!: number;
  @Prop({ default: false }) public readonly disabled!: boolean;
  @Prop({ default: 0 }) public readonly resetToken!: number;
  @Prop({ default: false }) public readonly buffered!: boolean;
  @Prop({ default: undefined }) public readonly pendingValue?: string;

  private fInputValue: number | string = this.value;
  private fHasPending = false;

  protected created(): void {
    this.onPendingValueChange();
  }

  get inputValue(): number | string {
    return this.fInputValue;
  }

  set inputValue(value: number | string) {
    this.fInputValue = value;
    if (this.buffered) {
      this.fHasPending = true;
      this.$emit("pending", String(value));
      return;
    }
    const numberValue = Number(value);
    if (!Number.isFinite(numberValue)) {
      return;
    }

    const normalizedValue = Math.min(
      Math.max(numberValue, minAllocationPercent),
      maxAllocationPercent
    );
    if (normalizedValue !== numberValue) {
      this.fInputValue = normalizedValue;
    }
    this.$emit("input", normalizedValue);
  }

  @Watch("value")
  private onValueChange(): void {
    if (this.pendingValue === undefined && Number(this.fInputValue) !== this.value) {
      this.fInputValue = this.value;
    }
  }

  @Watch("resetToken")
  private resetRejectedValue(): void {
    this.fInputValue = this.value;
  }

  @Watch("pendingValue")
  private onPendingValueChange(): void {
    this.fHasPending = this.pendingValue !== undefined;
    this.fInputValue = this.pendingValue === undefined ? this.value : this.pendingValue;
  }

  public commitBufferedValue(): void {
    if (this.buffered && (this.fHasPending || this.pendingValue !== undefined)) this.$emit("commit");
  }

  public onEnter(event: KeyboardEvent): void {
    if (!this.buffered) return;
    event.preventDefault();
    this.commitBufferedValue();
  }
}
